<template>
  <div class="sso-callback">
    로그인 처리 중...
  </div>
</template>

<script>
import { setAuthToken } from '@/utils/auth'

export default {
  name: 'SsoCallback',
  created () {
    // 백엔드가 토큰/에러를 URL fragment(#)로 전달한다.
    const raw = (window.location.hash || '').replace(/^#/, '')
    const params = new URLSearchParams(raw)

    const ssoError = params.get('ssoError')
    if (ssoError) {
      // SignIn이 에러를 표시하고 자동 리다이렉트를 멈추도록 query로 전달(루프 방지)
      this.$router.replace({ name: 'SignIn', query: { ssoError } })
      return
    }

    const accessToken = params.get('accessToken')
    const refreshToken = params.get('refreshToken')
    if (accessToken) {
      setAuthToken({ accessToken, refreshToken })
      this.$router.replace({ name: 'Dashboard' })
    } else {
      this.$router.replace({ name: 'SignIn' })
    }
  }
}
</script>

<style lang="scss" scoped>
.sso-callback {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  font-size: 16px;
  color: #666;
}
</style>
